<template>
  <div class="list">
    <div class="list-header">
      <div class="img-con">
        <img class="img" :src="item.avatar + '?imageView2/0/w/100/h/100'" alt="">
      </div>
      <div class="info-con">
        <div class="nike-name">{{ item.nickName }}</div>
        <van-rate
          v-model="item.descriptionScore"
          :size="11"
          color="#ffbc53"
          readonly
        />
      </div>
      <div class="time-con">{{ item.gmtCreate }}</div>
    </div>
    <div class="comment-con">
      <div class="comment-text">{{ item.commentInfo }}</div>
      <div class="grid-con">
        <van-grid
            :border="true"
            :gutter="5"
            :column-num="item.files.length===1? 1 : item.files.length===4? 2 : 3"
            :style="{ 'width': (item.files.length===1||item.files.length===4) ? '50.26%' : '74.72%' }"
        >
          <van-grid-item
              v-for="(file, i) in item.files"
              :key="i"
          >
            <van-image class="show-img" :src="file+'?imageView2/5/w/220/h/220'" @click="showImg(i)"/>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    item: {
      required: true,
    }
  },
  data(){
    return {

    }
  },
  methods: {
    //预览图片
    showImg(i){
      this.showImagePreview({images: this.item.files, startPosition: i})
    },
  }
}
</script>

<style lang="less" scoped>
.list{
  border-bottom: 1px solid #eee;padding-bottom: 12px;
  .list-header{
    height: 59px;display: flex;
    .img-con{
      display: inline-flex;width: 59px;height: 100%;justify-content: center;align-items: center;
      .img{width: 35px;height: 35px;border-radius: 50%;}
    }
    .info-con{
      flex: 1;padding: 12px 0;
      display: inline-flex;height: 100%;flex-direction: column;
      justify-content: space-between;align-items: flex-start;
      .nike-name{font-size: 15px;color: #333;line-height: 1;}
    }
    .time-con{
      display: inline-flex;height: 100%;font-size: 10px;padding: 0 12px;
      justify-content: center;align-items: center;color: #999;
    }
  }
  .comment-con{
    .comment-text{
      font-size: 12px;color: #333;padding: 0 12px;margin-bottom: 12px;
      overflow: hidden;text-overflow: ellipsis;
      display: -webkit-box;-webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-wrap: break-word;word-break: break-all;
    }
    .grid-con{
      padding-left: 7px;
      /deep/ .van-grid-item__content{
        padding: 0;
      }
    }
    .show-img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>